import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ServiceCardsComponent } from "./service-cards/service-cards.component";
import ServiceCardsRoutingModule from "./service-cards-routing.module";

@NgModule({
    declarations: [],
    imports: [
        RouterModule,
        CommonModule,
        ServiceCardsRoutingModule,
        ServiceCardsComponent
    ],
    exports: [
        ServiceCardsComponent
    ]
})

export class CardsModule { }
